import { render, staticRenderFns } from "./investModel.vue?vue&type=template&id=6dfd4b2a&scoped=true&"
import script from "./investModel.vue?vue&type=script&lang=js&"
export * from "./investModel.vue?vue&type=script&lang=js&"
import style0 from "./investModel.vue?vue&type=style&index=0&id=6dfd4b2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd4b2a",
  null
  
)

export default component.exports